import { createContext } from 'react';
import AuthProps from '../types/AuthProps';
// import { useStateManager } from '../hooks/useStateManager';

const defaultState: AuthProps = {};

const AuthContext = createContext<AuthProps>(defaultState);

export default AuthContext;
